module.exports = __webpack_public_path__ + "img/university-app-planning.33d27c2c.png";